// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__kIJhB","icon":"SortAdornment_icon__2WvA0","up":"SortAdornment_up__3DBYU","down":"SortAdornment_down__h5Y08","active":"SortAdornment_active__mW3gw"};